module.exports = __webpack_public_path__ + "img/939001690_2.8b50ad17.jpg";